var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"the-collection"}},[_c('b-container',{staticClass:"the-collection-container"},[_c('Header'),_c('div',{staticClass:"cards"},[_c('ProductCard',{staticClass:"collection-card",attrs:{"productCardId":1,"productData":{
          title: "PULLOVER HOODIE",
          buyurl: 'https://www.ivyshop.net/pages/respect',
          images: [
            require('@/assets/images/products/deguzman/sweatshirt-black-01.jpg'),
            require('@/assets/images/products/deguzman/sweatshirt-black-02.jpg'),
            require('@/assets/images/products/deguzman/sweatshirt-white-01.jpg'),
            require('@/assets/images/products/deguzman/sweatshirt-white-02.jpg') ],
          highResImages: [
            require('@/assets/images/products/deguzman/sweatshirt-black-01.jpg'),
            require('@/assets/images/products/deguzman/sweatshirt-black-02.jpg'),
            require('@/assets/images/products/deguzman/sweatshirt-white-01.jpg'),
            require('@/assets/images/products/deguzman/sweatshirt-white-02.jpg') ],
          productSaleInfo: {
            productAvailable: true,
            textDate: 'BUY NOW',
          },
        }}},[_c('h5',{attrs:{"slot":"product-title"},slot:"product-title"},[_vm._v(" PULLOVER"),_c('br'),_vm._v(" HOODIE ")]),_c('div',{attrs:{"slot":"description"},slot:"description"},[_c('p',[_vm._v(" This item features Louis De Guzman's artistic take on the club's iconic \"C\" headwear logo. ")])])]),_c('ProductCard',{staticClass:"collection-card",attrs:{"productCardId":2,"productData":{
          title: "SHORT-SLEEVE POCKET T-SHIRT",
          buyurl: 'https://www.ivyshop.net/pages/respect',
          images: [
            require('@/assets/images/products/deguzman/tee-black-01.jpg'),
            require('@/assets/images/products/deguzman/tee-black-02.jpg'),
            require('@/assets/images/products/deguzman/tee-white-01.jpg'),
            require('@/assets/images/products/deguzman/tee-white-02.jpg') ],
          highResImages: [
            require('@/assets/images/products/deguzman/tee-black-01.jpg'),
            require('@/assets/images/products/deguzman/tee-black-02.jpg'),
            require('@/assets/images/products/deguzman/tee-white-01.jpg'),
            require('@/assets/images/products/deguzman/tee-white-02.jpg') ],
          productSaleInfo: {
            productAvailable: true,
            textDate: 'BUY NOW',
          },
        }}},[_c('h5',{attrs:{"slot":"product-title"},slot:"product-title"},[_vm._v(" SHORT-SLEEVE"),_c('br'),_vm._v(" POCKET T-SHIRT ")]),_c('div',{attrs:{"slot":"description"},slot:"description"},[_c('p',[_vm._v(" This item features Louis De Guzman’s artistic take on the club’s iconic “C” headwear logo. ")])])]),_c('ProductCard',{staticClass:"collection-card",attrs:{"productCardId":3,"productData":{
          title: "MINIATURE REPLICA SCULPTURE",
          buyurl: 'https://www.ivyshop.net/pages/respect',
          images: [
            require('@/assets/images/products/deguzman/sculpture-01.jpg'),
            require('@/assets/images/products/deguzman/sculpture-02.jpg'),
            require('@/assets/images/products/deguzman/sculpture-03.jpg') ],
          highResImages: [
            require('@/assets/images/products/deguzman/sculpture-01.jpg'),
            require('@/assets/images/products/deguzman/sculpture-02.jpg'),
            require('@/assets/images/products/deguzman/sculpture-03.jpg') ],
          productSaleInfo: {
            productAvailable: true,
            textDate: 'BUY NOW',
          },
        }}},[_c('h5',{attrs:{"slot":"product-title"},slot:"product-title"},[_vm._v("MINIATURE REPLICA SCULPTURE")]),_c('div',{attrs:{"slot":"description"},slot:"description"},[_c('p',[_vm._v(" “COHERE” is designed in the shape of the Cubs’ “Angry Bear” logo and offers De Guzman’s creative interpretation of the iconic symbol with an emphasis on community and connection. ")]),_c('p',[_vm._v("Hand-painted resin sculpture")]),_c('p',[_vm._v("7.5\" W x 5\" D x 8\" H")]),_c('p',[_vm._v("Individually signed and dated by Louis De Guzman")])])])],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }